import { Cell, Checkbox, Grid } from 'bold-ui'
import { SearchInput } from 'components/search/SearchInput'

import { OrientacaoFilterModel } from '../model-orientacoes'

interface OrientacoesTableFilterProps {
  onChangeFilter(value: OrientacaoFilterModel)
  currentFilter: OrientacaoFilterModel
  isRetificacao?: boolean
}

export function OrientacoesTableFilter(props: Readonly<OrientacoesTableFilterProps>) {
  const { onChangeFilter, currentFilter, isRetificacao = false } = props

  const handleSearch = (filter: string) => onChangeFilter({ texto: filter, somenteMeus: currentFilter.somenteMeus })

  const searchPlaceholder = isRetificacao ? 'Pesquise por orientação' : 'Pesquise por profissional, CBO ou orientação'

  return (
    <Grid alignItems='center'>
      <Cell size={6}>
        <SearchInput dataTestId='SearchInput.Orientacoes' placeholder={searchPlaceholder} onSearch={handleSearch} />
      </Cell>
      <Cell size={6}>
        {!isRetificacao && (
          <Checkbox
            data-testid='Checkbox.VerSomenteMinhasOrientacoes'
            label='Ver somente as minhas orientações'
            onChange={() => onChangeFilter({ texto: currentFilter.texto, somenteMeus: !currentFilter.somenteMeus })}
          />
        )}
      </Cell>
    </Grid>
  )
}
